import { useCallback, useEffect, useState } from 'react';
import { account, bridge, type BridgeAccount } from './bridge';

/** 拉账号列表，默认选中第一个可写账号；支持 `?accountId=` 预选（原生入口带过来）。
 *
 * 返回 `reload()`：重新拉取（如用户去登录了新账号后回到页面）。 */
export function useAccounts() {
  const [accounts, setAccounts] = useState<BridgeAccount[]>([]);
  const [selectedId, setSelectedId] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(bridge.isNative);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!bridge.isNative) return;
    let cancelled = false;
    account
      .list()
      .then((list) => {
        if (cancelled) return;
        setAccounts(list);
        setSelectedId((prev) => {
          if (prev && list.some((a) => a.id === prev)) return prev;
          const requested = new URLSearchParams(window.location.search).get('accountId');
          const preferred =
            list.find((a) => a.id === requested) ??
            list.find((a) => a.canWrite) ??
            list[0];
          return preferred ? preferred.id : '';
        });
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : String(err));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tick]);

  const reload = useCallback(() => setTick((t) => t + 1), []);

  return { accounts, selectedId, setSelectedId, error, loading, reload };
}
